// The observation tabs' search params (screens doc §4.5): named like the operation's query params; only strings kept.
export function stringParams<K extends string>(
  search: Record<string, unknown>,
  names: readonly K[],
): Partial<Record<K, string>> {
  const out: Partial<Record<K, string>> = {};
  for (const name of names) {
    const value = search[name];
    if (typeof value === 'string' && value !== '') out[name] = value;
    else if (typeof value === 'number') out[name] = String(value);
  }
  return out;
}
